import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./registrationForm.module.css";
import axios from "axios";
import Header from "./dashboard-navbar";
import { dropdownDataUrl } from "../serviceUrls/ServiceUrl";
import CircularProgress from "@mui/material/CircularProgress";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Box, Typography, Tooltip } from "@mui/material";
import VerifyWhatsAppNumModal from "./VerifyWhatsAppNumModal";
import CheckIcon from "@mui/icons-material/Check";

// Constants moved outside component to prevent recreation
const ICONS = {
  unchecked: <CheckBoxOutlineBlankIcon fontSize="small" />,
  checked: <CheckBoxIcon fontSize="small" />,
};

const FOUND_US_OPTIONS = [
  { value: "Search Engine", option: "Search Engine" },
  { value: "Job-Boards", option: "Job-Boards" },
  { value: "Linkedin", option: "Linkedin" },
  { value: "Instagram, Facebook", option: "Instagram, Facebook" },
  {
    value: "Referral from a friend or colleague",
    option: "Referral from a friend or colleague",
  },
  { value: "Online advertisement", option: "Online advertisement" },
  { value: "others", option: "Others (Please specify)" },
];

const DEGREE_OPTIONS = [
  { value: "b-tech", label: "B.Tech" },
  { value: "m-tech", label: "M.Tech" },
  { value: "phd", label: "Phd" },
  { value: "other", label: "Other" },
];

const INITIAL_DATA = {
  email: "",
  name: "",
  branch: "",
  highest_degree: "",
  other_degree: "",
  university: "",
  skills: [],
  other_skill: [],
  best_subjects: [],
  software_skills: "",
  whatsapp_no: "",
  found_us_through: "",
  other_found_us_through_option: "",
};

// Create filter outside component
const filter = createFilterOptions();

const RegistrationForm = () => {
  const history = useNavigate();

  // State consolidation
  const [formData, setFormData] = useState(() => ({
    ...INITIAL_DATA,
    email: JSON.parse(localStorage?.getItem("tutor"))?.saveTutor?.email || "",
  }));

  const [uiState, setUiState] = useState({
    progressBar: false,
    addSubjectProgressBar: false,
    waVerifyProgressBar: false,
    isWhatsappVerified: false,
    waError: false,
    waErrorMsg: "",
    open: false,
    whatsappDialogOpen: false,
  });

  const [dropdownData, setDropdownData] = useState({
    branches: [],
    subjects: [],
  });

  const [selections, setSelections] = useState({
    skill: [],
    bestSub: [],
    newSubjectValue: "",
    verifiedNum: "",
  });
const [acceptTerms, setAcceptTerms] = useState(false);
  // Memoized validation
  const isFormValid = useMemo(() => {
    const {
      email,
      name,
      branch,
      highest_degree,
      university,
      skills,
      best_subjects,
      whatsapp_no,
      found_us_through,
      other_found_us_through_option,
    } = formData;

    return (
      email?.length > 0 &&
      name?.length > 0 &&
      branch?.length > 0 &&
      highest_degree?.length > 0 &&
      university?.length > 0 &&
      skills?.length > 0 &&
      best_subjects?.length > 0 &&
      whatsapp_no?.length > 0 &&
      found_us_through?.length > 0 &&
      (found_us_through !== "others" ||
        other_found_us_through_option?.length > 0)
    );
  }, [formData]);

  // Memoized filtered subjects for best subjects
  const filteredSkillsForBestSubjects = useMemo(() => {
    return selections.skill.filter((i) => i[0]?.trim() !== "Others");
  }, [selections.skill]);

  // Optimized input handlers with useCallback
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;

    setUiState((prev) => ({ ...prev, waError: false, waErrorMsg: "" }));

    if (name === "whatsapp_no") {
      setUiState((prev) => ({ ...prev, isWhatsappVerified: false }));
      const re = /^[0-9\b]+$/;
      if (value === "" || re.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  }, []);

  const handleDegreeChange = useCallback((e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
      other_degree: "",
    }));
  }, []);

  const handleFoundUsThroughChange = useCallback((e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
      other_found_us_through_option: "",
    }));
  }, []);

  const handleBestSub = useCallback((e) => {
    const value = e.target.value;
    setSelections((prev) => {
      const filter = prev.bestSub.filter((i) => i === value);
      if (filter.length === 0 && prev.bestSub.length < 5) {
        const newBestSub = [...prev.bestSub, value];
        setFormData((prevData) => ({
          ...prevData,
          best_subjects: newBestSub,
        }));
        return { ...prev, bestSub: newBestSub };
      }
      return prev;
    });
  }, []);

  // Optimized WhatsApp verification
  const handleWhatsappDialogOpen = useCallback(async () => {
    if (!formData.whatsapp_no) {
      alert("Please enter Whatsapp number");
      return;
    }
    if (!formData.name) {
      alert("Please enter your name");
      return;
    }

    setUiState((prev) => ({ ...prev, waVerifyProgressBar: true }));

    try {
      const response = await axios.post(
        "https://central-device-apis.el.r.appspot.com/d6/api/tutor/checkWaInDb",
        { wa_id: formData.whatsapp_no }
      );

      if (response?.data?.success) {
        setUiState((prev) => ({
          ...prev,
          waError: true,
          waVerifyProgressBar: false,
          waErrorMsg: "Whatsapp number already exist!",
        }));
      } else {
        setSelections((prev) => ({
          ...prev,
          verifiedNum: formData.whatsapp_no,
        }));
        setUiState((prev) => ({
          ...prev,
          whatsappDialogOpen: true,
          waVerifyProgressBar: false,
        }));
      }
    } catch (err) {
      setUiState((prev) => ({ ...prev, waVerifyProgressBar: false }));
    }
  }, [formData.whatsapp_no, formData.name]);

  // Optimized dialog handlers
  const handleWhatsappDialogClose = useCallback(() => {
    setUiState((prev) => ({ ...prev, whatsappDialogOpen: false }));
  }, []);

  const handleClose = useCallback(() => {
    setSelections((prev) => ({ ...prev, newSubjectValue: "" }));
    setUiState((prev) => ({ ...prev, open: false }));
  }, []);

  // Optimized subject addition
  const handleAddSubjects = useCallback(async () => {
    const { newSubjectValue } = selections;
    const { email, name, whatsapp_no } = formData;

    if (!newSubjectValue) {
      alert("Please enter atleast one subject!");
      return;
    }
    if (!email) {
      alert("Please enter your email!");
      return;
    }
    if (!name) {
      alert("Please enter your name!");
      return;
    }
    if (!whatsapp_no) {
      alert("Please enter your WhatsApp number!");
      return;
    }

    setUiState((prev) => ({ ...prev, addSubjectProgressBar: true }));

    try {
      const response = await axios.post(
        "https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorWeb/addNewSubjects",
        {
          name: name,
          subjects: newSubjectValue,
          wa_id: whatsapp_no,
          email: email,
        }
      );

      if (response.data.success) {
        setUiState((prev) => ({
          ...prev,
          addSubjectProgressBar: false,
          open: false,
        }));
        alert(
          "Request has been sent.We will notify you through email as soon as it is added to the list!!"
        );
      } else {
        setUiState((prev) => ({ ...prev, addSubjectProgressBar: false }));
        alert("Request failed! Please try again.");
      }
    } catch (err) {
      setUiState((prev) => ({ ...prev, addSubjectProgressBar: false }));
      alert("Request failed! Please try again.");
    }
  }, [formData, selections]);

  // Optimized form submission
  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (!isFormValid) {
        alert(
          "Submission failed! Please fill in all *required fields properly"
        );
        if (!acceptTerms) {
          alert("You must accept the Terms and Conditions before submitting.");
          return;
        }

        return;
      }

      setUiState((prev) => ({ ...prev, progressBar: true }));

      try {
        const tutorData = JSON.parse(localStorage.getItem("tutor"));
        const response = await axios.post(
          `https://testapis4.el.r.appspot.com/api/tutorweb/setTutorDetailsByForm/${tutorData.saveTutor.tutor_id}`,
          {
            email: formData.email,
            name: formData.name,
            branch: formData.branch,
            highest_degree: formData.highest_degree,
            university: formData.university,
            skills: formData.skills,
            best_subjects: formData.best_subjects,
            wa_id: formData.whatsapp_no,
            software_skills: formData.software_skills,
            tutStatus: "ex",
            found_us_through:
              formData.found_us_through === "others"
                ? formData.other_found_us_through_option
                : formData.found_us_through,
          }
        );

        if (response.status === 200 && response.data.tutors) {
          // Update localStorage
          const updatedTutorData = {
            ...tutorData,
            saveTutor: {
              ...tutorData.saveTutor,
              ...formData,
              wa_id: formData.whatsapp_no,
              tutStatus: "ex",
            },
          };
          localStorage.setItem("tutor", JSON.stringify(updatedTutorData));

          setFormData(INITIAL_DATA);
          setUiState((prev) => ({ ...prev, progressBar: false }));
          history("/tutor_exam",{replace:true});
        } else if (response.status === 200 && response.data.waExist) {
          setUiState((prev) => ({
            ...prev,
            waError: true,
            progressBar: false,
            waErrorMsg: "Whatsapp number already exist!",
          }));
        } else if (
          response.status === 200 &&
          !response.data.contactValidationSuccess
        ) {
          setUiState((prev) => ({
            ...prev,
            progressBar: false,
            waError: true,
            waErrorMsg: "Invalid whatsapp number!",
          }));
        } else {
          setUiState((prev) => ({ ...prev, progressBar: false }));
          alert("Form not submitted. Please try again!");
        }
      } catch (err) {
        setUiState((prev) => ({ ...prev, progressBar: false }));
        console.error("Form submission error:", err);
        alert("Form submission failed. Please try again!");
      }
    },
    [isFormValid, formData, history]
  );

  // Optimized autocomplete handlers
  const handleSkillChange = useCallback((event, newValue) => {
    if (
      newValue &&
      newValue.length !== 0 &&
      newValue[newValue.length - 1][0]?.includes("Add")
    ) {
      setUiState((prev) => ({ ...prev, open: true }));
      setSelections((prev) => ({
        ...prev,
        newSubjectValue: newValue[newValue.length - 1][1],
      }));
    } else {
      setSelections((prev) => ({ ...prev, skill: newValue || [] }));
      setFormData((prev) => ({ ...prev, skills: newValue ? newValue[0] : [] }));
    }
  }, []);

  const filterOptions = useCallback((options, params) => {
    const filtered = filter(options, params);
    if (params.inputValue !== "") {
      filtered.push([`Add "${params.inputValue}"`, params.inputValue]);
    }
    return filtered;
  }, []);

  // Data fetching with error handling
  useEffect(() => {
    let isMounted = true;

    const fetchDropdownData = async () => {
      try {
        const response = await axios.get(dropdownDataUrl);
        if (isMounted) {
          setDropdownData({
            branches: response?.data?.branch || [],
            subjects: response?.data?.subject || [],
          });
        }
      } catch (err) {
        console.error("Failed to fetch dropdown data:", err);
      }
    };

    fetchDropdownData();

    return () => {
      isMounted = false;
    };
  }, []);

  // Render optimizations with memoized components
  const renderBestSubjectChips = useMemo(
    () => (
      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
        {selections.bestSub.map((el, i) => (
          <div
            key={`${el}-${i}`}
            style={{
              color: "#404040",
              width: "fit-content",
              border: "1px solid darkgray",
              padding: "0px 7px 0px 7px",
              borderRadius: "4px",
              cursor: "pointer",
              margin: "3px",
            }}
            onClick={() => {
              setSelections((prev) => {
                const newBestSub = prev.bestSub.filter(
                  (_, index) => index !== i
                );
                setFormData((prevData) => ({
                  ...prevData,
                  best_subjects: newBestSub,
                }));
                return { ...prev, bestSub: newBestSub };
              });
            }}
          >
            {el} x
          </div>
        ))}
      </div>
    ),
    [selections.bestSub]
  );

  return (
    <>
      <Header />
      <div className={classes["main_container"]}>
        <div className={classes.main} style={{ textAlign: "-webkit-center" }}>
          <div className={classes.container} style={{ marginTop: "6rem" }}>
            <form className={classes["appointment-form"]} id="appointment-form">
              <h2 className={classes.heading} style={{ marginBottom: "35px" }}>
                Registration Form For Doers
              </h2>

              {/* Info section */}
              <div
                style={{
                  height: "9rem",
                  overflowY: "scroll",
                  borderBottom: "ridge",
                  marginBottom: "15px",
                }}
              >
                <p>
                  <b>Attention Doers!</b>
                  <br />
                  Unlock Opportunities in High-Demand Subjects
                </p>
                <p style={{ fontSize: "13px" }}>
                  Why should you consider becoming a Doer in high-demand
                  subjects?
                  <br />
                  • Growing demand and increased amount of tasks.
                  <br />
                  • Competitive advantage: Doers who have cleared the test will
                  be given priority
                  <br />• Higher opportunity to earn
                </p>
                <p>High-Demand Subjects</p>
                <p style={{ fontSize: "13px" }}>
                  1. Artificial Intelligence
                  <br />
                  2. Project Management
                  <br />
                  3. Algorithms
                  <br />
                  4. Database Management System(DBMS)
                  <br />
                  5. Computer Networking
                  <br />
                  6. Marketing Management
                  <br />
                  7. Cloud Computing
                  <br />
                  8. Computer Architecture
                  <br />
                  9. Operating System
                  <br />
                  10. Machine Learning (ML) and Other Data Science topics
                </p>
              </div>

              {/* Form instructions */}
              <div style={{ fontSize: "13px", marginBottom: "1rem" }}>
                <p style={{ margin: "0px" }}>
                  • Please make sure that you use country code while entering
                  WhatsApp no.
                </p>
                <p style={{ margin: "0px" }}>
                  • Please leave no gaps or spaces while entering email id or
                  any other information.
                </p>
                <p style={{ margin: "0px" }}>*Required field</p>
              </div>

              <div className={classes["form-group-2"]}>
                {/* Email field */}
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  className={classes["input_class1"]}
                  placeholder="Email *"
                  readOnly
                  required
                />

                {/* Name field */}
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  className={classes["input_class1"]}
                  onChange={handleChange}
                  placeholder="Full Name (As per your PAN Card) *"
                  required
                />

                {/* Branch select */}
                <select
                  name="branch"
                  value={formData.branch}
                  className={classes["input_class1"]}
                  onChange={handleChange}
                  required
                >
                  <option value="">Branch/Specialization/Department *</option>
                  {dropdownData.branches.map((branch) => (
                    <option key={branch} value={branch}>
                      {branch}
                    </option>
                  ))}
                </select>

                {/* Degree select */}
                <select
                  name="highest_degree"
                  value={formData.highest_degree}
                  className={classes["input_class1"]}
                  onChange={handleDegreeChange}
                  required
                >
                  <option value="">Highest Degree *</option>
                  {DEGREE_OPTIONS.map((degree) => (
                    <option key={degree.value} value={degree.value}>
                      {degree.label}
                    </option>
                  ))}
                </select>

                {/* Other degree input */}
                {formData.highest_degree === "other" && (
                  <input
                    type="text"
                    name="other_degree"
                    placeholder="Please mention *"
                    value={formData.other_degree}
                    className={classes["input_class1"]}
                    onChange={handleChange}
                    required
                  />
                )}

                {/* University field */}
                <input
                  type="text"
                  name="university"
                  value={formData.university}
                  className={classes["input_class1"]}
                  placeholder="University/Colleges (with separated comma) *"
                  onChange={handleChange}
                  required
                />

                {/* Skills Autocomplete */}
                <div className={classes["select-list-skill"]}>
                  <Autocomplete
                    multiple
                    value={selections.skill}
                    onChange={handleSkillChange}
                    filterOptions={filterOptions}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    options={dropdownData.subjects}
                    groupBy={(option) => option[1]}
                    disableCloseOnSelect
                    getOptionLabel={(option) => {
                      if (typeof option === "string") return option;
                      if (option.inputValue) return option.inputValue;
                      return option[0];
                    }}
                    renderOption={(props, option, { selected }) => (
                      <li key={option[0]} {...props}>
                        <Checkbox
                          icon={ICONS.unchecked}
                          checkedIcon={ICONS.checked}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option[0]}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Skills/Known Subjects (upto 20)*"
                        placeholder="Subjects"
                        variant="standard"
                      />
                    )}
                    renderGroup={(params) => (
                      <li key={params.key}>
                        <div
                          style={{
                            position: "sticky",
                            top: "-8px",
                            padding: "4px 10px",
                            color: "#71abe7",
                            backgroundColor: "#d0dfef",
                          }}
                        >
                          {params.group}
                        </div>
                        <ul>{params.children}</ul>
                      </li>
                    )}
                  />
                </div>

                {/* Best Subjects */}
                <div className={classes["select-list-skill"]}>
                  <select
                    name="best_subjects"
                    value={
                      selections.bestSub[selections.bestSub.length - 1] || ""
                    }
                    className={classes["input_class1"]}
                    onChange={handleBestSub}
                    required
                  >
                    <option value="">Best Subjects (upto 5) *</option>
                    {filteredSkillsForBestSubjects.map((skill) => (
                      <option key={skill[0]} value={skill[0]}>
                        {skill[0]}
                      </option>
                    ))}
                  </select>
                  {renderBestSubjectChips}
                </div>

                {/* Software Skills */}
                <input
                  type="text"
                  name="software_skills"
                  value={formData.software_skills}
                  className={classes["input_class1"]}
                  placeholder="Software Skills (with separated comma)"
                  onChange={handleChange}
                />

                {/* WhatsApp Number */}
                <Box sx={{ display: "flex" }}>
                  <input
                    type="number"
                    name="whatsapp_no"
                    value={formData.whatsapp_no}
                    className={classes["input_class1"]}
                    placeholder="Whatsapp No.(with country code and without any symbol eg.'+', '*' ..etc) *"
                    onChange={handleChange}
                    style={{
                      borderBlockColor: uiState.waError ? "red" : "initial",
                    }}
                    required
                  />
                  {uiState.isWhatsappVerified ? (
                    <Button
                      variant="outlined"
                      color="success"
                      sx={{ alignSelf: "flex-start" }}
                      startIcon={<CheckIcon />}
                    >
                      Verified
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      sx={{ alignSelf: "flex-start" }}
                      onClick={handleWhatsappDialogOpen}
                      disabled={uiState.waVerifyProgressBar}
                    >
                      {uiState.waVerifyProgressBar && (
                        <CircularProgress
                          size={22}
                          style={{ marginRight: "10px" }}
                          color="inherit"
                        />
                      )}
                      Verify
                    </Button>
                  )}
                </Box>

                {/* WhatsApp Error/Success Message */}
                {uiState.waError ? (
                  <p
                    style={{
                      color: "red",
                      marginTop: "-30px",
                      fontSize: "12px",
                    }}
                  >
                    {uiState.waErrorMsg}
                  </p>
                ) : (
                  <p
                    style={{
                      color: "#00a300",
                      marginTop: "-30px",
                      fontSize: "12px",
                    }}
                  >
                    *Please fill correct WhatsApp Number with country code!
                  </p>
                )}

                {/* Found Us Through */}
                <select
                  name="found_us_through"
                  value={formData.found_us_through}
                  className={classes["input_class1"]}
                  onChange={handleFoundUsThroughChange}
                  required
                >
                  <option value="">
                    Where did you first discover our website?*
                  </option>
                  {FOUND_US_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.option}
                    </option>
                  ))}
                </select>

                {/* Other Found Us Through */}
                {formData.found_us_through === "others" && (
                  <input
                    type="text"
                    name="other_found_us_through_option"
                    value={formData.other_found_us_through_option}
                    className={classes["input_class1"]}
                    placeholder="*Please mention the other source where you found our website?"
                    onChange={handleChange}
                    required
                  />
                )}
              </div>

              {/* Terms and Conditions */}
              <div className={classes["form-check"]}>
                <label
                  className={classes["label-agree-term"]}
                  style={{ fontSize: "15px" }}
                >
                  <input
                    type="checkbox"
                    checked={acceptTerms}
                    onChange={(e) => setAcceptTerms(e.target.checked)}
                    style={{ marginRight: "6px" }}
                  />
                  I agree that I have read the{" "}
                  <a
                    href="https://Urdoer.com/privacyPolicy"
                    target="_blank"
                    rel="noreferrer"
                    className={classes["term-service"]}
                  >
                    Privacy and Policy
                  </a>
                </label>
              </div>

              {/* Submit Button */}
              <div className={classes["form-submit"]}>
                {uiState.isWhatsappVerified ? (
                  <button
                    type="submit"
                    className={classes.submit}
                    style={{ display: "flex", alignItems: "center" }}
                    onClick={handleSubmit}
                    disabled={uiState.progressBar}
                  >
                    {uiState.progressBar && (
                      <CircularProgress
                        size={22}
                        style={{ marginRight: "10px" }}
                        color="inherit"
                      />
                    )}
                    Submit
                  </button>
                ) : (
                  <Tooltip title="Your WhatsApp number is not verified" arrow>
                    <Typography
                      sx={{
                        color: "text.disabled",
                        backgroundColor: "#f5f5f5",
                        padding: "8px 16px",
                        borderRadius: "4px",
                        textAlign: "center",
                        cursor: "not-allowed",
                      }}
                      component="div"
                    >
                      Submit
                    </Typography>
                  </Tooltip>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Add Subject Dialog */}
      <Dialog open={uiState.open} onClose={handleClose}>
        <DialogTitle>Request to add a subject</DialogTitle>
        <DialogContent>
          <DialogContentText>
            If you are not able to find your subject in our list, please submit
            a request to add it!
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            value={selections.newSubjectValue}
            onChange={(event) =>
              setSelections((prev) => ({
                ...prev,
                newSubjectValue: event.target.value,
              }))
            }
            label="Add Subjects"
            type="text"
            variant="standard"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={handleAddSubjects}
            disabled={uiState.addSubjectProgressBar}
          >
            Add
            {uiState.addSubjectProgressBar && (
              <CircularProgress
                size={22}
                style={{ marginLeft: "10px" }}
                color="inherit"
              />
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* WhatsApp Verification Modal */}
      {uiState.whatsappDialogOpen && (
        <VerifyWhatsAppNumModal
          open={uiState.whatsappDialogOpen}
          handleClose={handleWhatsappDialogClose}
          setIsWhatsappVerified={(verified) =>
            setUiState((prev) => ({ ...prev, isWhatsappVerified: verified }))
          }
          waNum={selections.verifiedNum}
          name={formData.name}
        />
      )}
    </>
  );
};

export default RegistrationForm;
